<template>
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{$t('label.Inquiry.InquiryFor')}}</span>
        <Icon type="ios-create-outline" class="applyicon" />
        <!-- <Button type="primary" long  class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
        </Button>-->
      </div>
      <!-- 主表 -->
      <Form ref="formdata" :model="formdata" :rules="rule">
        <!-- 主表表单 -->
        <table class="form-table form-table-print">
          <tbody>
            <tr>
              <!-- 询价编号 -->
              <th class="requiredIitm">{{$t('label.Inquiry.InquiryNo')}}</th>
              <td>
                <Form-item prop="inquiryId">
                  <Input type="text" v-model="formdata.inquiryId" disabled />
                </Form-item>
              </td>
              <!-- 申请人 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Applicants')}}</th>
              <td>
                <Form-item prop="applicantUserId">
                  <Input type="text" v-model="sqr" disabled />
                </Form-item>
              </td>
              <!-- 申请日期 -->
              <th class="requiredIitm">{{$t('label.Inquiry.ApplicationDate')}}</th>
              <td>
                <Form-item prop="applyDate">
                  <ab-date
                    :disabled="true"
                    style="width:100%;"
                    v-model="formdata.applyDate"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
            </tr>
            <!-- 新加功能 公司-据点选择 -->
            <tr>
              <!-- 公司 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryCompany') }}</span>
              </th>
              <td>
                <Form-item prop="applyCompanyName">
                  <Input type="text" v-model="formdata.applyCompanyName" disabled />
                </Form-item>
              </td>
              <!-- 据点 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryStronghoId') }}</span>
              </th>
              <td>
                <Form-item prop="applyStrongholdName">
                  <Input type="text" v-model="formdata.applyStrongholdName" disabled />
                </Form-item>
              </td>
              <!-- 部门 -->
              <th class="requiredIitm">{{$t('label.Inquiry.ApplyDepartment')}}</th>
              <td>
                <Form-item prop="applyDepartmentName">
                  <Input type="text" v-model="formdata.applyDepartmentName" disabled />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 报价截止日 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Deadline')}}</th>
              <td>
                <Form-item prop="quoteDeadline">
                  <ab-date
                    :disabled="true"
                    style="width:100%;"
                    v-model="formdata.quoteDeadline"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
              <!-- 案件名 -->
              <th class="requiredIitm"><span>{{$t('label.Inquiry.caseName')}}</span></th>
              <td colspan="3">
                <Form-item prop="caseName">
                  <Input type="text" v-model="formdata.caseName" disabled  />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 背景目的 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Purpose')}}</th>
              <td colspan="5">
                <Form-item prop="objective">
                  <Input type="textarea" autosize v-model="formdata.objective" disabled />
                </Form-item>
              </td>
            </tr>
            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅人事可见 -->
              <th class="requiredIitm">
              <span>{{$t('label.Inquiry.inform')}}</span>
              </th>
              <td colspan="5" style="text-align:left;">
                <Form-item prop="inform">
                  <RadioGroup v-model="formdata.inform">
                      <Radio
                        disabled
                        label="1"
                      >{{$t('LABEL-011')}}</Radio>
                      <Radio
                        disabled
                        label="0"
                      >{{$t('LABEL-010')}}</Radio>
                    </RadioGroup>
                </Form-item>
              </td>
            </tr>
            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅总务可见 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.limit')}}</span>
              </th>
              <td colspan="5" style="text-align:left;">
                <Form-item prop="limit">
                  <RadioGroup v-model="formdata.limit">
                    <Radio disabled label="1">{{$t('LABEL-011')}}</Radio>
                    <Radio disabled label="0">{{$t('LABEL-010')}}</Radio>
                  </RadioGroup>
                </Form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 其他事项 -->
        <div>
          <div
            class="table_box"
            @mouseover="pmdisplayover"
            @mouseout="pmdisplayout"
          >
            <div class="itemTitle">
              <Icon type="ios-information-circle" class="icon" />
              <span
                style="cursor: pointer;font-size:13px;"
              >{{$t('label.Inquiry.PurchaseTips')}}</span>
              
              <Icon type="ios-help-circle-outline" class="icon" style="margin-left:10px;color:#000;"/>
            </div>
            <table class="i-iview-table form-table" style="margin-top:10px;" v-show="pmdisplayflg">
              <thead>
                <tr class="firstRow">
                  <th style="width:5%;">
                    <span style="font-size: 14px;">{{'NO.'}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Physical.Item')}}</span>
                  </th>
                  <th style="width:15%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.PurchasingDepartment')}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Consulting')}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val,index) in contactList" :key="index" style="height:42px;">
                  <td style="">{{index+1}}</td>
                  <td style="text-align:left;" v-html="val.name"></td>
                  <td style="text-align:left;" v-html="val.content"></td>
                  <td style="text-align:left;" v-html="val.contactNumber"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <Form-item>
        <Button type="primary" @click="handleSubmit('formdata')">提交</Button>
        <Button type="primary" @click="handleReset('formdata')" style="margin-left: 8px">重置</Button>
        </Form-item>-->
      </Form>
      <!-- 实物购入 -->
      <Card
        style="margin-top:15px;"
        :class="{'cardnonepadding':!formDynamic.items || formDynamic.items.length===0}"
        v-if="formDynamic.items"
      >
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.PhysicalA')}}</span>
          <!-- <Button type="primary" long @click="handleAdd(0)" class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
          </Button>-->
        </div>
        <Form ref="formDynamic" :rules="rules" :model="formDynamic" class="form-table-th-margin">
          <!-- 实物购入明细部分 -->
          <div
            v-for="(item, index) in formDynamic.items"
            :key="index"
            :class="{'content':index !== formDynamic.items.length-1}"
          >
            <table class="form-table form-table-print">
              <tbody>
                <tr>
                  <th class="requiredIitm">{{$t('label.Inquiry.Physical.Item')}}</th>
                  <td>
                    <Form-item :prop="'items.' + index + '.itemName'" :rules="rules.itemName">
                      <Input type="text" v-model="item.itemName" placeholder disabled />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">{{$t('label.Inquiry.Physical.Specifications')}}</th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.specifications'"
                      :rules="rules.specifications"
                    >
                      <Input type="text" v-model="item.specifications" placeholder disabled />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">{{$t('label.Inquiry.Physical.Sum')}}</th>
                  <td>
                    <Form-item :prop="'items.' + index + '.quantity'" :rules="rules.quantity">
                      <InputNumber
                        class="wrongNumber"
                        :active-change="false"
                        style="width:100%;"
                        :min="0"
                        v-model="item.quantity"
                        disabled
                      ></InputNumber>
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <th class="requiredIitm">{{$t('label.Inquiry.Physical.Satisfied')}}</th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.deliveryDeadline'"
                      :rules="rules.deliveryDeadline"
                    >
                      <ab-date
                        :disabled="true"
                        style="width:100%;"
                        v-model="item.deliveryDeadline"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                  <th class>{{$t('label.Inquiry.Physical.Attachment')}}</th>
                  <td>
                    <ab-upload v-model="item.file" abPermission="w" :disabled="true"></ab-upload>
                  </td>
                  <th class>{{$t('label.Inquiry.Physical.Note')}}</th>
                  <td>
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.note===''"
                        :content="item.note"
                        :transfer="true"
                      >  
                      <Form-item :prop="'items.' + index + '.note'">
                        <Input type="text" v-model="item.note" placeholder disabled />
                      </Form-item>
                    </Tooltip>  
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 理由内容 -->
            <div class="typebox" v-if="item.swgysList && item.swgysList.length===1">
              <span class="requiredIitm">{{$t('label.Inquiry.Reason')}} :</span>
              <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                <RadioGroup v-model="item.incompleteQr" class="right30">
                  <Radio label="0" disabled>{{$t('label.Inquiry.Rause')}}</Radio>
                  <Radio label="1" disabled>{{$t('label.Inquiry.HoldingCompany')}}</Radio>
                  <Radio label="2" disabled>{{$t('label.Inquiry.University')}}</Radio>
                  <!-- <Radio label="3" disabled>{{$t('label.Inquiry.CooperationProject')}}</Radio> -->
                  <Radio label="4" disabled>{{$t('label.Inquiry.Other')}}</Radio>
                </RadioGroup>
              </Form-item>
              <Form-item
                :prop="'items.' + index + '.incompleteQrt'"
                :rules="rules.incompleteQrt"
                v-if="item.incompleteQr==='4'"
              >
                <Input type="text" v-model="item.incompleteQrt" placeholder disabled />
              </Form-item>
            </div>

            <!-- 实物购入供应商部分 -->
            <div style="margin-top:15px;">
              <!-- <div style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;" >
              <div>
                <Button type="primary" @click="add(index,0)" style="margin-right:10px;">
                  <Icon type="ios-add" style="margin-right:5px;" />添加供应商
                </Button>
                <Button
                  type="primary"
                  @click="copy(index,0)"
                  style="margin-right:10px;"
                  v-if="formDynamic.items[0].swgysList.length>0 && index!==0 && formDynamic.items.length>0"
                >
                  <Icon type="ios-add" style="margin-right:5px;" />复制供应商
                </Button>
                <Button type="error" @click="handleRemove(index,0)">
                  <Icon type="ios-alert-outline" style="margin-right:5px;" />删除明细
                </Button>
              </div>
              </div>-->
              <Table
                highlight-row
                border
                :columns="columns"
                :data="item.swgysList"
                :no-data-text="''"
                v-if="item.swgysList && item.swgysList.length>0"
              >
                <!-- 选择 -->
                <template slot-scope="{ row }" slot="select">
                  <Checkbox
                    v-if="removeSupplier(item.swgysList[row._index])"
                    :disabled="permission.swgys.choose!=='w'"
                    v-model="item.swgysList[row._index].choose"
                    @on-change="selectitem($event,item.swgysList,row._index,row,item,)"
                    :true-value="'1'"
                    :false-value="'0'"
                  />
                </template>
                <!-- 选定理由 -->
                <template slot-scope="{ row }" slot="selectReason">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.selectReason`"
                    v-if="row.choose!=='1'"
                  >
                    <Input type="text" disabled />
                  </FormItem>
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.selectReason`"
                    :rules="rules.selectReason"
                    v-if="row.choose==='1'"
                  >
                    <Input
                      type="text"
                      v-model="item.swgysList[row._index].selectReason"
                      :disabled="permission.swgys.selectReason!=='w'"
                    />
                  </FormItem>
                </template>
                <!-- 供应商名称 -->
                <template slot-scope="{ row }" slot="vendorName">
                  <Tooltip
                    max-width="400"
                    style="display:flex;width:100%;"
                    :disabled="item.swgysList[row._index].vendorName===''"
                    :content="item.swgysList[row._index].vendorName"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.vendorName`"
                      :rules="rules.vendorName"
                    >
                      <Input type="text" disabled v-model="item.swgysList[row._index].vendorName" />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人 -->
                <template slot-scope="{ row }" slot="client">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.client`"
                    :rules="rules.client"
                  >
                    <Input type="text" disabled v-model="item.swgysList[row._index].client" />
                  </FormItem>
                </template>
                <!-- 联系方式 -->
                <template slot-scope="{ row }" slot="contact">
                  <Tooltip
                    style="display:flex;width:100%;"
                    max-width="400"
                    :content="item.swgysList[row._index].contact"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.contact`"
                      :rules="rules.contact"
                    >
                      <Input type="text" disabled v-model="item.swgysList[row._index].contact" />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人邮箱 -->
                <template slot-scope="{ row }" slot="email">
                  <Tooltip
                    max-width="400"
                    style="display:flex;width:100%;"
                    :disabled="item.swgysList[row._index].email===''"
                    :content="item.swgysList[row._index].email"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.email`"
                      :rules="rules.email"
                    >
                      <Input type="text" disabled v-model="item.swgysList[row._index].email" />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 不含税价格 -->
                <template slot-scope="{ row }" slot="excludingTaxPrice">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.excludingTaxPrice`"
                    :rules="rules.excludingTaxPrice"
                  >
                    <InputNumber
                      disabled
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      @on-change="numberchange($event,item.swgysList[row._index],0)"
                      v-model="item.swgysList[row._index].excludingTaxPrice"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 含税价格 -->
                <template slot-scope="{ row }" slot="includingTaxPrice">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.includingTaxPrice`"
                    :rules="rules.includingTaxPrice"
                  >
                    <InputNumber
                      disabled
                      @on-change="numberchange($event,item.swgysList[row._index],1)"
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      v-model="item.swgysList[row._index].includingTaxPrice"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 比价金额 -->
                <template slot-scope="{ row }" slot="priceAmount">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.priceAmount`"
                    :rules="rules.priceAmount"
                  >
                    <InputNumber
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      disabled
                      v-model="item.swgysList[row._index].priceAmount"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 调整后比价金额 -->
                <template slot-scope="{ row }" slot="changePriceamount">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.changePriceamount`"
                    :rules="!removeSupplier(item.swgysList[row._index]) || permission.swgys.changePriceamount!=='w' || row.choose!=='1' ? null : [{ trigger: 'change',validator:(rule,value,callback)=>PriceamountCheck(rule, value, callback, row, 0, index, row._index)}]"
                  >
                    <InputNumber
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      :disabled="!removeSupplier(item.swgysList[row._index]) || permission.swgys.changePriceamount!=='w' || row.choose!=='1'"
                      v-model="item.swgysList[row._index].changePriceamount"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 税率 -->
                <!-- <template slot-scope="{ row }" slot="taxRate">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.taxRate`"
                    :rules="rules.taxRate"
                  >
                    <InputNumber
                      disabled
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      style="width:100%;"
                      :precision="2"
                      :min="0"
                      v-model="item.swgysList[row._index].taxRate"
                    ></InputNumber>
                  </FormItem>
                </template> -->
                <!-- 发票区分 -->
                <template slot-scope="{ row }" slot="invoiceType">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.invoiceType`"
                    :rules="rules.invoiceType"
                  >
                    <RadioGroup
                      v-model="item.swgysList[row._index].invoiceType"
                      @on-change="numberchange($event,item.swgysList[row._index],2)"
                    >
                      <Radio disabled label="0">{{$t('label.Inquiry.GeneralTicket')}}</Radio>
                      <Radio disabled label="1">{{$t('label.Inquiry.TicketIncrease')}}</Radio>
                    </RadioGroup>
                  </FormItem>
                </template>
                <!-- 报价有效开始日 -->
                <template slot-scope="{ row }" slot="priceStartDate">
                  <Form-item
                    :prop="`items.${index}.swgysList.${row._index}.priceStartDate`"
                    :rules="rules.priceStartDate"
                  >
                    <ab-date
                      :disabled="true"
                      style="width:100%;"
                      v-model="item.swgysList[row._index].priceStartDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                  </Form-item>
                </template>
                <!-- 报价有效截至日 -->
                <template slot-scope="{ row }" slot="priceEndDate">
                  <Form-item
                    :prop="`items.${index}.swgysList.${row._index}.priceEndDate`"
                    :rules="!removeSupplier(item.swgysList[row._index]) ? null : [{ trigger: 'change',validator:(rule,value,callback)=>{endCheck(rule,value,callback,row)}}]"
                  >
                    <ab-date
                      v-if="row.choose==='1'"
                      :disabled="permission.swgys.changeFile!=='w'"
                      style="width:100%;"
                      v-model="item.swgysList[row._index].priceEndDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                    <ab-date
                      v-else
                      disabled
                      style="width:100%;"
                      v-model="item.swgysList[row._index].priceEndDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                  </Form-item>
                </template>
                <!-- 调整比价金额附件 -->
                <template slot-scope="{ row }" slot="changeFile">
                  <Form-item
                    :prop="`items.${index}.swgysList.${row._index}.changeFile`"
                    :rules="!removeSupplier(item.swgysList[row._index]) || permission.swgys.changeFile!=='w' || row.choose!=='1' ? null : [{ trigger: 'change',validator:(rule,value,callback)=>uploadCheck(rule,value,callback,row,0,index,row._index)}]"
                  >
                    <ab-upload
                      :ref="'sw' + index + row._index"
                      v-model="item.swgysList[row._index].changeFile"
                      abPermission="w"
                      :disabled="!removeSupplier(item.swgysList[row._index]) || permission.swgys.changeFile!=='w' || row.choose!=='1'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                  </Form-item>
                </template>
                <!-- 附件 -->
                <template slot-scope="{ row }" slot="detailFile">
                  <ab-upload
                    v-model="item.swgysList[row._index].detailFile"
                    abPermission="w"
                    :disabled="true"
                    :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                  ></ab-upload>
                </template>
                <!-- 备注 -->
                <template slot-scope="{ row }" slot="note">
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.swgysList[row._index].note===''"
                        :content="item.swgysList[row._index].note"
                        :transfer="true"
                      >  
                      <FormItem
                        :prop="`items.${index}.swgysList.${row._index}.note`"
                        :rules="rules.note"
                      >
                        <Input type="text" v-model="item.swgysList[row._index].note" disabled />
                      </FormItem>
                    </Tooltip>   
                </template>
              </Table>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
      <!-- 服务 -->
      <Card
        style="margin-top:15px;"
        :class="{'cardnonepadding':!formService.items || formService.items.length===0}"
        v-if="formService.items"
      >
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.Service.ServiceContent')}}</span>
          <!-- <Button type="primary" @click="handleAdd(1)" class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
          </Button>-->
        </div>
        <Form ref="formService" :rules="rules" :model="formService" class="form-table-th-margin">
          <!-- 服务明细部分 -->
          <div
            v-for="(item, index) in formService.items"
            :key="index"
            :class="{'content':index !== formService.items.length-1}"
          >
            <table class="form-table form-table-print">
              <tbody>
                <tr>
                  <th class="requiredIitm">{{$t('label.Inquiry.EntrustedContent')}}</th>
                  <td>
                    <Form-item :prop="'items.' + index + '.entrustment'" :rules="rules.entrustment">
                      <Input type="text" v-model="item.entrustment" placeholder disabled />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">{{$t('label.Inquiry.StartTime')}}</th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.businessHoursStart'"
                      :rules="rules.businessHoursStart"
                    >
                      <ab-date
                        :disabled="true"
                        style="width:100%;"
                        v-model="item.businessHoursStart"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                  <th class="requiredIitm">{{$t('label.Inquiry.EndTime')}}</th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.businessHoursEnd'"
                      :rules="rules.businessHoursEnd"
                    >
                      <ab-date
                        :disabled="true"
                        style="width:100%;"
                        v-model="item.businessHoursEnd"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <th class="requiredIitm">{{$t('label.Inquiry.Service.Safety')}}</th>
                  <td style="text-align:left;">
                    <FormItem
                      :prop="'items.' + index + '.securityType'"
                      :rules="rules.securityType"
                    >
                      <RadioGroup v-model="item.securityType">
                        <Radio label="0" disabled>{{$t('label.Inquiry.Service.WorkHigh')}}</Radio>
                        <Radio label="1" disabled>{{$t('label.Inquiry.Service.FlameCperation ')}}</Radio>
                        <Radio label="2" disabled>{{$t('label.Inquiry.Service.Hydrogen')}}</Radio>
                        <Radio label="3" disabled>{{$t('label.Inquiry.Service.NO')}}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </td>
                  <th class>{{$t('label.Inquiry.Service.Attachment')}}</th>
                  <td>
                    <ab-upload v-model="item.file" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                  </td>
                  <th class>{{$t('label.Inquiry.Service.Note')}}</th>
                  <td>
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.note===''"
                        :content="item.note"
                        :transfer="true"
                      >  
                    <Form-item :prop="'items.' + index + '.note'">
                      <Input type="text" v-model="item.note" placeholder disabled />
                    </Form-item>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 理由内容 -->
            <div class="typebox" v-if="item.fwgysList && item.fwgysList.length===1">
              <span class="requiredIitm">{{$t('label.Inquiry.Reason')}} :</span>
              <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                <RadioGroup v-model="item.incompleteQr" disabled class="right30">
                  <Radio label="0" disabled>{{$t('label.Inquiry.Rause')}}</Radio>
                  <Radio label="1" disabled>{{$t('label.Inquiry.HoldingCompany')}}</Radio>
                  <Radio label="2" disabled>{{$t('label.Inquiry.University')}}</Radio>
                  <!-- <Radio label="3" disabled>{{$t('label.Inquiry.CooperationProject')}}</Radio> -->
                  <Radio label="4" disabled>{{$t('label.Inquiry.Other')}}</Radio>
                </RadioGroup>
              </Form-item>
              <Form-item
                :prop="'items.' + index + '.incompleteQrt'"
                :rules="rules.incompleteQrt"
                v-if="item.incompleteQr==='4'"
              >
                <Input type="text" v-model="item.incompleteQrt" placeholder disabled />
              </Form-item>
            </div>
            <!-- 服务供应商部分 -->
            <div style="margin-top:15px;">
              <div
                style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;"
              >
                <!-- <div>
                <Button type="primary" @click="add(index,1)" style="margin-right:10px;">
                  <Icon type="ios-add" style="margin-right:5px;" />添加供应商
                </Button>
                <Button
                  type="primary"
                  @click="copy(index,1)"
                  style="margin-right:10px;"
                  v-if="formDynamic.items.length>0 && formDynamic.items[0].swgysList.length>0"
                >
                  <Icon type="ios-add" style="margin-right:5px;" />复制供应商
                </Button>
                <Button type="error" @click="handleRemove(index,1)">
                  <Icon type="ios-alert-outline" style="margin-right:5px;" />删除明细
                </Button>
                </div>-->
              </div>
              <Table
                border
                :columns="columns"
                :data="item.fwgysList"
                :no-data-text="''"
                v-if="item.fwgysList && item.fwgysList.length>0"
              >
                <!-- 选择 -->
                <template slot-scope="{ row }" slot="select">
                  <Checkbox
                    v-if="removeSupplier(item.fwgysList[row._index])"
                    :disabled="permission.fwgys.choose!=='w'"
                    v-model="item.fwgysList[row._index].choose"
                    @on-change="selectitem($event,item.fwgysList,row._index,row,item,'service' + index + row._index)"
                    :true-value="'1'"
                    :false-value="'0'"
                  />
                </template>
                <!-- 选定理由 -->
                <template slot-scope="{ row }" slot="selectReason">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.selectReason`"
                    v-if="row.choose!=='1'"
                  >
                    <Input type="text" disabled />
                  </FormItem>
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.selectReason`"
                    :rules="rules.selectReason"
                    v-if="row.choose==='1'"
                  >
                    <Input
                      type="text"
                      v-model="item.fwgysList[row._index].selectReason"
                      :disabled="permission.fwgys.selectReason!=='w'"
                    />
                  </FormItem>
                </template>
                <!-- 供应商名称 -->
                <template slot-scope="{ row }" slot="vendorName">
                  <Tooltip
                    max-width="400"
                    style="display:flex;width:100%;"
                    :disabled="item.fwgysList[row._index].vendorName===''"
                    :content="item.fwgysList[row._index].vendorName"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.vendorName`"
                      :rules="rules.vendorName"
                    >
                      <Input type="text" v-model="item.fwgysList[row._index].vendorName" disabled />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人 -->
                <template slot-scope="{ row }" slot="client">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.client`"
                    :rules="rules.client"
                  >
                    <Input type="text" v-model="item.fwgysList[row._index].client" disabled />
                  </FormItem>
                </template>
                <!-- 联系方式 -->
                <template slot-scope="{ row }" slot="contact">
                  <Tooltip
                    style="display:flex;width:100%;"
                    max-width="400"
                    :content="item.fwgysList[row._index].contact"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.contact`"
                      :rules="rules.contact"
                    >
                      <Input type="text" v-model="item.fwgysList[row._index].contact" disabled />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人邮箱 -->
                <template slot-scope="{ row }" slot="email">
                  <Tooltip
                    max-width="400"
                    style="display:flex;width:100%;"
                    :disabled="item.fwgysList[row._index].email===''"
                    :content="item.fwgysList[row._index].email"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.email`"
                      :rules="rules.email"
                    >
                      <Input type="text" v-model="item.fwgysList[row._index].email" disabled />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 不含税价格 -->
                <template slot-scope="{ row }" slot="excludingTaxPrice">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.excludingTaxPrice`"
                    :rules="rules.excludingTaxPrice"
                  >
                    <InputNumber
                      disabled
                      @on-change="numberchange($event,item.fwgysList[row._index],0)"
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      v-model="item.fwgysList[row._index].excludingTaxPrice"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 含税价格 -->
                <template slot-scope="{ row }" slot="includingTaxPrice">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.includingTaxPrice`"
                    :rules="rules.includingTaxPrice"
                  >
                    <InputNumber
                      disabled
                      @on-change="numberchange($event,item.fwgysList[row._index],1)"
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :min="0"
                      v-model="item.fwgysList[row._index].includingTaxPrice"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 比价金额 -->
                <template slot-scope="{ row }" slot="priceAmount">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.priceAmount`"
                    :rules="rules.priceAmount"
                  >
                    <InputNumber
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      disabled
                      :min="0"
                      v-model="item.fwgysList[row._index].priceAmount"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 调整后比价金额 -->
                <template slot-scope="{ row }" slot="changePriceamount">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.changePriceamount`"
                    :rules="!removeSupplier(item.fwgysList[row._index]) || permission.fwgys.changePriceamount!=='w' || row.choose!=='1' ? null : [{ trigger: 'change',validator:(rule,value,callback)=>PriceamountCheck(rule, value, callback, row, 1, index, row._index)}]"
                  >
                    <InputNumber
                      :active-change="false"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\s?|(,*)/g, '')"
                      :precision="2"
                      style="width:100%;"
                      :disabled="!removeSupplier(item.fwgysList[row._index]) || permission.fwgys.changePriceamount!=='w' || row.choose!=='1'"
                      :min="0"
                      v-model="item.fwgysList[row._index].changePriceamount"
                    ></InputNumber>
                  </FormItem>
                </template>
                <!-- 税率 -->
                <!-- <template slot-scope="{ row }" slot="taxRate">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.taxRate`"
                    :rules="rules.taxRate"
                  >
                    <InputNumber
                      :precision="2"
                      disabled
                      :formatter="value => `${value}%`"
                      :parser="value => value.replace('%', '')"
                      style="width:100%;"
                      :min="0"
                      v-model="item.fwgysList[row._index].taxRate"
                    ></InputNumber>
                  </FormItem>
                </template> -->
                <!-- 发票区分 -->
                <template slot-scope="{ row }" slot="invoiceType">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.invoiceType`"
                    :rules="rules.invoiceType"
                  >
                    <RadioGroup
                      v-model="item.fwgysList[row._index].invoiceType"
                      @on-change="numberchange($event,item.fwgysList[row._index],2)"
                    >
                      <Radio disabled label="0">{{$t('label.Inquiry.GeneralTicket')}}</Radio>
                      <Radio disabled label="1">{{$t('label.Inquiry.TicketIncrease')}}</Radio>
                    </RadioGroup>
                  </FormItem>
                </template>
                <!-- 报价有效开始日 -->
                <template slot-scope="{ row }" slot="priceStartDate">
                  <Form-item
                    :prop="`items.${index}.fwgysList.${row._index}.priceStartDate`"
                    :rules="rules.priceStartDate"
                  >
                    <ab-date
                      :disabled="true"
                      style="width:100%;"
                      v-model="item.fwgysList[row._index].priceStartDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                  </Form-item>
                </template>
                <!-- 报价有效截至日 -->
                <template slot-scope="{ row }" slot="priceEndDate">
                  <Form-item
                    :prop="`items.${index}.fwgysList.${row._index}.priceEndDate`"
                    :rules="!removeSupplier(item.fwgysList[row._index]) ? null : [{ trigger: 'change',validator:(rule,value,callback)=>{endCheck(rule,value,callback,row)}}]"
                  >
                    <ab-date
                      v-if="row.choose==='1'"
                      :disabled="permission.fwgys.changeFile!=='w'"
                      style="width:100%;"
                      v-model="item.fwgysList[row._index].priceEndDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                    <ab-date
                      v-else
                      disabled
                      style="width:100%;"
                      v-model="item.fwgysList[row._index].priceEndDate"
                      format="yyyy-MM-dd"
                    ></ab-date>
                  </Form-item>
                </template>
                <!-- 调整比价金额附件 -->
                <template slot-scope="{ row }" slot="changeFile">
                  <Form-item
                    :prop="`items.${index}.fwgysList.${row._index}.changeFile`"
                    :rules="!removeSupplier(item.fwgysList[row._index]) || permission.fwgys.changeFile!=='w' || row.choose!=='1' ? null : [{ trigger: 'change',validator:(rule,value,callback)=>uploadCheck(rule,value,callback,row,1,index,row._index)}]"
                  >
                    <ab-upload
                      :ref="'service' + index + row._index"
                      v-model="item.fwgysList[row._index].changeFile"
                      abPermission="w"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                      :disabled="!removeSupplier(item.fwgysList[row._index]) || permission.fwgys.changeFile!=='w' || row.choose!=='1'"
                    ></ab-upload>
                  </Form-item>
                </template>
                <!-- 附件 -->
                <template slot-scope="{ row }" slot="detailFile">
                  <ab-upload
                    v-model="item.fwgysList[row._index].detailFile"
                    abPermission="w"
                    :disabled="true"
                    :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                  ></ab-upload>
                </template>
                <!-- 备注 -->
                <template slot-scope="{ row }" slot="note">
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="item.fwgysList[row._index].note===''"
                        :content="item.fwgysList[row._index].note"
                        :transfer="true"
                      >
                      <FormItem
                        :prop="`items.${index}.fwgysList.${row._index}.note`"
                        :rules="rules.note"
                      >
                        <Input type="text" v-model="item.fwgysList[row._index].note" disabled />
                      </FormItem>
                    </Tooltip>  
                </template>
              </Table>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
    </Card>
    <Modal
      v-model="dodal_a"
      :mask-closable="false"
      :title="$t('label.Inquiry.Tips')"
      @on-ok="isok"
      :ok-text="$t('label.Inquiry.Agree')"
      @on-cancel="cancel"
    >
      <p>{{$t('ERR.Inquiry.008')}}</p>
    </Modal>
  </div>
</template>
<script>
import util from '@/libs/util';
export default {
  data: function() {
    return {
      contactList: [
        {
          name: $t("label.Inquiry.Camera"),
          content: $t("label.Inquiry.LegalAffairs"),
          contactNumber: $t("label.Inquiry.Liyan")
        },
        {
          name: $t("label.Inquiry.Display"),
          content: $t("label.Inquiry.SystemCourse"),
          contactNumber: $t("label.Inquiry.LiuYuanYuan")
        },
        {
          name: $t("label.Inquiry.Stationery"),
          content: $t("label.Inquiry.GeneralAffairsSection"),
          contactNumber: $t("label.Inquiry.ChenYan")
        },
        {
          name: $t("label.Inquiry.VehicleRelated"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.GuLingYan")
        },
        {
          name: $t("label.Inquiry.SpareParts"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.DingXianHua")
        },
        {
          name: $t("label.Inquiry.VehicleAccess"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.ZhangYiTing")
        }
      ],
      list_a: [],
      list_b: [],
      sqr: "",
      detail: false,
      selectValue: null,
      selectdata: null,
      dodal_a: false,
      pmdisplayflg: false,
      //实物数据
      formDynamic: {
        items: [
          {
            itemName: "",
            specifications: "",
            quantity: "",
            deliveryDeadline: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            swgysList: []
          }
        ]
      },
      //服务数据
      formService: {
        items: [
          {
            entrustment: "",
            businessHoursStart: "",
            businessHoursEnd: "",
            securityType: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            fwgysList: []
          }
        ]
      },
      //供应商校验规则
      rules: {
        //调整后的比价金额
        changePriceamount: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this,'label.InquiryOfferApprove.ChangePriceamount'),
            trigger: "change"
          }
        ],
        //调整附件
        changeFile: [
          {
            required: true,
            message: util.getmsg(this,'label.InquiryOfferApprove.ChangeFile'),
            trigger: "change"
          }
        ],
        //实物明细
        itemName: [
          //请输入品名
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Item"),
            trigger: "change"
          }
        ],
        specifications: [
          // 请输入规格
          {
            required: true,
            message:
              $t("ERR-000") + $t("label.Inquiry.Physical.Specifications"),
            trigger: "change"
          }
        ],
        // 请输入备考
        note: [
          {
            required: false,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Note"),
            trigger: "change"
          }
        ],
        deliveryDeadline: [
          // 请输入纳期
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Satisfied"),
            trigger: "change"
          }
        ],
        quantity: [
          // 请输入数量
          {
            required: true,
            type: "number",
            message: $t("ERR-000") + $t("label.Inquiry.Physical.Sum"),
            trigger: "change"
          }
        ],

        //服务明细
        entrustment: [
          // 委托内容不能为空
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EntrustedContent"),
            trigger: "change"
          }
        ],
        securityType: [
          // 安全确认不能为空
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Service.Safety"),
            trigger: "change"
          }
        ],
        file: [
          // 委托内容不能为空
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.EntrustedContent"),
            trigger: "change"
          }
        ],
        businessHoursStart: [
          {
            // 业务开始时间不能为空
            required: true,
            message: $t("ERR-000") + $t("label.InquiryPrice.BusinessStart"),
            trigger: "change"
          }
        ],
        businessHoursEnd: [
          {
            // 业务结束时间不能为空
            required: true,
            message: $t("ERR-000") + $t("label.InquiryPrice.BusinessEnd"),
            trigger: "change"
          }
        ],
        //共用供应商校验
        incompleteQr: [
          {
            // 相見積もり徹底できない理由不能为空
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Reason"),
            trigger: "change"
          }
        ],
        incompleteQrt: [
          {
            // 其他不能为空
            required: true,
            message:
              $t("ERR-000") +
              $t("label.Inquiry.Reason") +
              $t("label.Inquiry.Reason"),
            trigger: "change"
          }
        ],
        vendorId: [
          // 供应商ID
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierID"),
            trigger: "change"
          }
        ],
        vendorName: [
          // 供应商名称不能为空
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
            trigger: "change"
          }
        ],
        client: [
          // 联系人不能为空
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
            trigger: "change"
          }
        ],
        email: [
          // 邮箱不能为空
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Email"),
            trigger: "change"
          }
        ],
        contact: [
          // 电话不能为空
          {
            required: true,
            message:
              $t("ERR-000") +
              $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
            trigger: "change"
          }
        ],
        excludingTaxPrice: [
          {
            required: false,
            type: "number",
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding"),
            trigger: "change"
          }
        ],
        includingTaxPrice: [
          {
            required: false,
            type: "number",
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"),
            trigger: "change"
          }
        ],
        priceAmount: [
          {
            required: false,
            type: "number",
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount"),
            trigger: "change"
          }
        ],
        taxRate: [
          {
            required: false,
            type: "number",
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.Rate"),
            trigger: "change"
          }
        ],
        invoiceType: [
          {
            required: false,
            message: $t("ERR-000") + $t("label.InquiryPrice.Invoice"),
            trigger: "change"
          }
        ],
        priceStartDate: [
          {
            required: false,
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart"),
            trigger: "change"
          }
        ],
        priceEndDate: [
          {
            required: false,
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd"),
            trigger: "change"
          }
        ],
        detailFile: [
          {
            required: false,
            message:
              $t("ERR-000") +
              $t("label.InquiryOfferApprove.SupplierDetail.Attachment"),
            trigger: "change"
          }
        ],
        note: [
          {
            required: false,
            message: $t("ERR-000") + $t("label.InquiryPrice.Note"),
            trigger: "change"
          }
        ],
        selectReason: [
          {
            required: true,
            message: util.getmsg(this,'label.InquiryDecisionApprove.Reason'),
            trigger: "change"
          }
        ]
      },
      // 主表校验规则
      rule: {
        inform: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.inform"),
            trigger: "change"
          }
        ],
        breakupBidFlg: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.InquiryOfferApprove.Separable"),
            trigger: "change"
          }
        ],
        applicantUserId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Applicants"),
            trigger: "change"
          }
        ],
        applyDepartmentName: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.ApplyDepartment"),
            trigger: "change"
          }
        ],
        applyDate: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.ApplicationDate"),
            trigger: "change"
          }
        ],
        quoteDeadline: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Deadline"),
            trigger: "change"
          }
        ],
        inquiryId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.InquiryNo"),
            trigger: "change"
          }
        ],
        objective: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Purpose"),
            trigger: "change"
          }
        ]
      },
      //实物表格列
      columns: [
        //选择项
        {
          title: $t("label.InquiryDecisionApprove.Choose"),
          slot: "select",
          align: "center",
          width: 70,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryDecisionApprove.Choose")
            );
          }
        },
        //选定理由
        {
          title: $t("label.InquiryDecisionApprove.Reason"),
          slot: "selectReason",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryDecisionApprove.Reason")
            );
          }
        },
        //供应商名称
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
          slot: "vendorName",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName")
            );
          }
        },
        //比价金额
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount"),
          slot: "priceAmount",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceAmount")
            );
          }
        },
        //普票增票
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Invoice"),
          slot: "invoiceType",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Invoice")
            );
          }
        },
        //含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices"),
          slot: "includingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PostTaxPrices")
            );
          }
        },
        //不含税价格
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding"),
          slot: "excludingTaxPrice",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.PriceExcluding")
            );
          }
        },
        //调整后比价金额
        {
          title: $t(
            "label.InquiryOfferApprove.ChangePriceamount"
          ),
          slot: "changePriceamount",
          align: "center",
          width: 140,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.ChangePriceamount")
            );
          }
        },
        //税率
        // {
        //   title: $t("label.InquiryOfferApprove.SupplierDetail.Rate"),
        //   slot: "taxRate",
        //   align: "center",
        //   width: 200,
        //   renderHeader: (h, params) => {
        //     return h(
        //       "div",
        //       { class: "requiredIitm" },
        //       $t("label.InquiryOfferApprove.SupplierDetail.Rate")
        //     );
        //   }
        // },
        //报价开始日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart"),
          slot: "priceStartDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationStart")
            );
          }
        },
        //报价结束日
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd"),
          slot: "priceEndDate",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.QuotationEnd")
            );
          }
        },
        //调整报价附件
        {
          title: $t("label.InquiryOfferApprove.ChangeFile"),
          slot: "changeFile",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.ChangeFile")
            );
          }
        },
        //附件
        {
          title: $t("label.InquiryOfferApprove.SupplierDetail.Attachment"),
          slot: "detailFile",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOfferApprove.SupplierDetail.Attachment")
            );
          }
        },
        //备考
        {
          title: $t("label.Inquiry.Physical.Note"),
          slot: "note",
          align: "center",
          width: 200
        },
        //联系人
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
          slot: "client",
          align: "center",
          width: 150,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Contact")
            );
          }
        },
        //电话
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
          slot: "contact",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Phone")
            );
          }
        },
        //邮箱
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Email"),
          slot: "email",
          align: "center",
          width: 210,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Email")
            );
          }
        }
      ]
    };
  },
  props: {
    parent: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.formdata = this.parent.data.xjsq;
    this.permission = this.parent.permission.xjsq;
    this.formDynamic.items = this.formdata.xjswgrList;
    this.formService.items = this.formdata.fwxxList;
    this.list_a = JSON.parse(JSON.stringify(this.formdata.xjswgrList));
    this.list_b = JSON.parse(JSON.stringify(this.formdata.fwxxList));
    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      : false;
    this.abHttpUtil
      .post("/common/getFullName?account=" + this.formdata.applicantUserId)
      .then(res => {
        this.sqr = res;
      });
    this.initNumber();
  },
  computed: {
    validate_a() {
      var flg_a = false;
      if (this.formDynamic.items && this.formDynamic.items.length > 0) {
        flg_a = this.formDynamic.items.every(val => {
          // 供应商全部放弃报价 输出true ；否则判断 是否有选择项，有则输出true 无则false
          var check_a = val.swgysList.every(element =>{
            return !this.removeSupplier(element) ? true : false
          })
          return check_a ? true : val.swgysList.some(item => {
            return item.choose === "1";
          });
        });
      } else {
        flg_a = true;
      }

      var flg_b = false;
      if (this.formService.items && this.formService.items.length > 0) {
        flg_b = this.formService.items.every(val => {
          var check_b = val.fwgysList.every(element =>{
            return !this.removeSupplier(element) ? true : false
          })
          return check_b ? true : val.fwgysList.some(item => {
            return item.choose === "1";
          });
        });
      } else {
        flg_b = true;
      }
      return flg_a && flg_b;
    }
  },
  mounted() {
  },
  methods: {
    //表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      let flg = 0;
      let validateflg = false;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if (this.$refs.formDynamic) {
        this.$refs.formDynamic.validate(valid => {
          if (valid) {
            flg++;
          }
        });
      }
      if (this.$refs.formService) {
        this.$refs.formService.validate(valid => {
          if (valid) {
            flg++;
          }
        });
      }
      var count =
        this.formDynamic.items && this.formService.items
          ? 3
          : this.formDynamic.items || this.formService.items
          ? 2
          : 999;
      if (flg === count && this.validate_a) {
        this.$parent.data.xjsq = { ...this.formdata };
        this.$parent.data.xjsq.xjswgrList = this.formDynamic.items;
        this.$parent.data.xjsq.fwxxList = this.formService.items;
        validateflg = true;
      } else {
        var list = [];
        if (!this.validate_a) {
          list.push($t("ERR.Inquiry.010"));
        }
        this.errmsg(list);
        validateflg = false;
      }
      return validateflg;
    },
    //表单重置
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 品目鼠标移入事件
    pmdisplayover() {
      this.pmdisplayflg = true;
    },
    // 品目鼠标移出事件
    pmdisplayout() {
      this.pmdisplayflg = false;
    },
    //明细添加
    handleAdd(type) {
      if (type === 0) {
        this.formDynamic.items.push({
          itemName: "",
          specifications: "",
          quantity: "",
          deliveryDeadline: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          swgysList: []
        });
      } else if (type === 1) {
        this.formService.items.push({
          entrustment: "",
          businessHoursStart: "",
          businessHoursEnd: "",
          securityType: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          fwgysList: []
        });
      }
    },
    //明细删除
    handleRemove(index, type) {
      if (type === 0) {
        this.formDynamic.items.splice(index, 1);
      } else if (type === 1) {
        this.formService.items.splice(index, 1);
      }
    },
    //删除供应商
    remove(index, row, type) {
      if (type === 0) {
        this.formDynamic.items[index].swgysList.splice(row._index, 1);
      } else if (type === 1) {
        this.formService.items[index].fwgysList.splice(row._index, 1);
      }
    },
    // 添加供应商
    add(index, type) {
      let obj = {
        vendorId: "",
        vendorName: "",
        client: "",
        priceAmount: "",
        contact: "",
        email: "",
        excludingTaxPrice: null,
        includingTaxPrice: null,
        priceAmount: null,
        taxRate: null,
        invoiceType: "",
        priceStartDate: "",
        priceEndDate: "",
        detailFile: "",
        note: ""
      };
      if (type === 0) {
        this.formDynamic.items[index].swgysList.push(obj);
      } else if (type === 1) {
        this.formService.items[index].fwgysList.push(obj);
      }
    },
    //供应商复制
    copy(index, type) {
      if (type === 0) {
        this.formDynamic.items[
          index
        ].swgysList = this.formDynamic.items[0].swgysList;
      }
      if (type === 1) {
        this.formService.items[
          index
        ].fwgysList = this.formDynamic.items[0].swgysList;
      }
    },
    //model添加供应商
    pushOrgRelationList(dataArr, type, obj) {
      if (!dataArr) {
        return;
      }
      if (type === 0) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
      if (type === 1) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
    },
    //税率，比价金额计算事件
    numberchange(e, data, type) {
      // 0不含税金额 excludingTaxPrice
      // 1含税金额 includingTaxPrice
      // 2普票/增票 invoiceType
      // 比价金额 priceAmount
      // 税率 taxRate
      if (type === 0) {
        if (data.invoiceType === "1") {
          //增票为不含税金额
          data.priceAmount = e;
        }
        if (data.includingTaxPrice && data.includingTaxPrice !== "") {
          data.taxRate = ((data.includingTaxPrice - e) / e) * 100;
        }
      }
      if (type === 1) {
        if (data.invoiceType === "0") {
          //普票为含税金额
          data.priceAmount = e;
        }
        if (data.excludingTaxPrice && data.excludingTaxPrice !== "") {
          data.taxRate =
            ((e - data.excludingTaxPrice) / data.excludingTaxPrice) * 100;
        }
      }
      if (type === 2) {
        //e=1增票时使用不含税金额
        //e=0普票是使用含税金额
        data.priceAmount =
          e === "1"
            ? data.excludingTaxPrice
            : e === "0"
            ? data.includingTaxPrice
            : "";
      }
    },
    //供应商选择事件
    selectitem(e, data, count, row, item, refUpload) {
      var listtext = [
        $t("label.Inquiry.Rause"),
        $t("label.Inquiry.HoldingCompany"),
        $t("label.Inquiry.University"),
        $t("label.Inquiry.CooperationProject")
      ];
      //选中事件
      if (e === "1") {
        this.selectValue = row.vendorId;
        this.selectdata = data;
        //只有一个供应商带入不选择其他供应商理由
        if (data.length === 1) {
          this.$set(data[0],'selectReason',item.incompleteQr === "4" ? item.incompleteQrt : listtext[parseInt(item.incompleteQr)])
        }
        //清空其他选项的值
        //清空前判断当前数组有没有不接受拆分报价的供应商 
        data.forEach((val, index) => {
          if (index !== count && val.choose === "1") {
            this.$set(val,'choose','0')
            this.$set(val,'selectReason','')
            this.$set(val,'changeFile',null)
            this.$set(val,'changePriceamount',null)
          }
        });
      }
      //未选中
      if (e === "0") {
        //清空选项的选定理由
        data.forEach((val, index) => {
          if (val.choose === "0") {
            this.$set(val,'choose','0')
            this.$set(val,'selectReason','')
            this.$set(val,'changeFile',null)
            this.$set(val,'changePriceamount',null)
          }
        });
      }
      //选中且供应商不接受拆分报价
      if (e === "1" && row.breakupBidFlg === "0") {
        this.dodal_a = true;
      }
      //不选中且供应商不接受拆分报价
      if (e === "0" && row.breakupBidFlg === "0") {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (item.vendorId === this.selectValue) {
              this.$set(item, "choose", "0");
              this.$set(item, "selectReason", "");
              this.$set(item, "changeFile", null);
              this.$set(item, "changePriceamount", null);
            }
          });
        });
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (item.vendorId === this.selectValue) {
              this.$set(item, "choose", "0");
              this.$set(item, "selectReason", "");
              this.$set(item, "changeFile", null);
              this.$set(item, "changePriceamount", null);
            }
          });
        });
      }
    },
    cancel() {
      this.selectdata.forEach(val => {
        val.choose = "0";
        val.selectReason = "";
        (val.changeFile = null), (val.changePriceamount = null);
      });
    },
    isok() {
      var listtext = [
        $t("label.Inquiry.Rause"),
        $t("label.Inquiry.HoldingCompany"),
        $t("label.Inquiry.University"),
        $t("label.Inquiry.CooperationProject")
      ];
      this.formService.items.forEach(val => {
        val.fwgysList.forEach(item => {
          if (item.vendorId === this.selectValue) {
            this.$set(item, "choose", "1");
            this.$set(item,"selectReason",val.incompleteQr === "" ? "" : val.incompleteQr === "4" ? val.incompleteQrt : listtext[parseInt(val.incompleteQr)]);
          }else if(val.fwgysList.some(value=>value.vendorId===this.selectValue)){
            this.$set(item, "choose", "0");
            this.$set(item, "selectReason", "");
          }
        });
      });
      this.formDynamic.items.forEach(val => {
        val.swgysList.forEach(item => {
          if (item.vendorId === this.selectValue) {
            this.$set(item, "choose", "1");
            this.$set(item, "selectReason", val.incompleteQr === "" ? "" : val.incompleteQr === "4" ? val.incompleteQrt : listtext[parseInt(val.incompleteQr)]
            );
          }else if(val.swgysList.some(value=>value.vendorId===this.selectValue)){
            this.$set(item, "choose", "0");
            this.$set(item, "selectReason", "");
          }
        });
      });
    },
    //判断供应商是否放弃报价 false放弃报价 true有报价
    removeSupplier(data) {
      var flg_a = true;
      if (!data.excludingTaxPrice) {
        flg_a = false;
      }
      return flg_a;
    },
    errmsg(custom) {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        if (custom.length > 0) {
          errMsg = errMsg.concat(custom);
        }
        errMsg.forEach(val => {
          this.$Message.error({ content: val, duration: 5 });
        });
      });
    },
    //重置数字字段参数
    initNumber() {
      if (this.formDynamic.items.length > 0) {
        this.formDynamic.items.forEach(val => {
          val.swgysList.forEach(item => {
            if (!item.changeFile) {
              this.$set(item, "changeFile", null);
            }
            if (!item.excludingTaxPrice) {
              this.$set(item, "excludingTaxPrice", null);
            }
            if (!item.includingTaxPrice) {
              this.$set(item, "includingTaxPrice", null);
            }
            if (!item.priceAmount) {
              this.$set(item, "priceAmount", null);
            }
            if (!item.taxRate) {
              this.$set(item, "taxRate", null);
            }
            if (!item.changePriceamount) {
              this.$set(item, "changePriceamount", null);
            }
          });
        });
      }
      if (this.formService.items.length > 0) {
        this.formService.items.forEach(val => {
          val.fwgysList.forEach(item => {
            if (!item.changeFile) {
              this.$set(item, "changeFile", null);
            }
            if (!item.excludingTaxPrice) {
              this.$set(item, "excludingTaxPrice", null);
            }
            if (!item.includingTaxPrice) {
              this.$set(item, "includingTaxPrice", null);
            }
            if (!item.priceAmount) {
              this.$set(item, "priceAmount", null);
            }
            if (!item.taxRate) {
              this.$set(item, "taxRate", null);
            }
            if (!item.changePriceamount) {
              this.$set(item, "changePriceamount", null);
            }
          });
        });
      }
    },
    //报价截止日变化判断  false 变化了, true 无变化
    changeDate(date, type, index, count) {
      var flg = false;
      if (type === 0) {
        flg =
          this.list_a[index].swgysList[count].priceEndDate === date
            ? true
            : false;
      } else {
        flg =
          this.list_b[index].fwgysList[count].priceEndDate === date
            ? true
            : false;
      }
      return flg;
    },
    //调整附件check
    //截止日有修改 必输
    //调整后报价有值 必输
    uploadCheck(rule,value,callback, row, type, index, count) {
      var file = type===0 ? this.formDynamic.items[index].swgysList[count].changeFile : this.formService.items[index].fwgysList[count].changeFile
      var date = type===0 ? this.formDynamic.items[index].swgysList[count].priceEndDate : this.formService.items[index].fwgysList[count].priceEndDate
      var fileflg = !file || file.length <= 2 ? false : true
      //console.log(file,date,row.changePriceamount,this.changeDate(date, type, index, count),fileflg,'附件check')
      if ( (!this.changeDate(date, type, index, count) || row.changePriceamount) && !fileflg) { //（金额有值||日期有变化） && 附件没值
        callback(new Error(util.getmsg(this,'label.InquiryOfferApprove.ChangeFile')))
      }else{
        callback();
      }
    },
    //调整报价金额check
    //截止日有修改 必输
    //调整后报价附件有值 必输
    PriceamountCheck(rule, value, callback, row, type, index, count) {
      var file = type===0 ? this.formDynamic.items[index].swgysList[count].changeFile : this.formService.items[index].fwgysList[count].changeFile
      var date = type===0 ? this.formDynamic.items[index].swgysList[count].priceEndDate : this.formService.items[index].fwgysList[count].priceEndDate
      var fileflg = !file || file.length <= 2 ? false : true
      //console.log(file,date,this.changeDate(date, type, index, count),fileflg,'金额check')
      if(value===row.priceAmount){
        callback(util.getmsg(this,'label.InquiryOfferApprove.ChangePriceamountErr'));
      }
      if ( (this.changeDate(date, type, index, count) && fileflg) && !value) { // 附件有上传 且 日期没变化 =>check
        callback(util.getmsg(this,'label.InquiryOfferApprove.ChangePriceamount'));
      } else{
        callback()
      }
    },
    //报价截止日check
    endCheck(rule, value, callback, row) {
      // console.log(value,'1----')
      var start = this.moment(row.priceStartDate).format("YYYY-MM-DD").replace(/-/g, "");
      var end = this.moment(value).format("YYYY-MM-DD").replace(/-/g, "");
      if(!value){
        callback(util.getmsg(this,'label.InquiryOfferApprove.SupplierDetail.QuotationEnd'))
      }else if(start>end){
        callback($t("ERR.Inquiry.007"))
      }else{
        callback()
      }
    },
  }
};
</script>
<style scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  color: #2d8cf0;
}
.titlebox {
  display: flex;
  align-items: center;
}
.typebox {
  display: flex;
  align-items: center;
  margin: 15px 0px;
}
.typebox > span {
  margin-right: 5px;
}
</style>
